import { UpperCasePipe } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar, MatSnackBarRef } from '@angular/material/snack-bar';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { PropertyService } from 'src/app/_shared/service/property.service';
import { UserState } from 'src/app/_shared/state/user.state';
import { AppState } from 'src/app/app.state';
import { CmaService } from 'src/app/cma/cma.service';
import { CmaState } from 'src/app/cma/cma.state';
import { ForgotPasswordService } from 'src/app/forgot-password/forgot-password.service';
import { LoginAlerts } from 'src/app/login/login.interface';
import { LoginService } from 'src/app/login/login.service';
import { ProfileService } from 'src/app/profile/profile.service';
import { ReportsState } from 'src/app/reports/reports.state';
import { DialogComponent } from 'src/app/shared/modules/alerts/dialog/dialog.component';
import { CookieStorageService } from 'src/app/shared/service/cookie-storage.service';
import constants from 'src/constant.json';

const errorObj = { type: 'info', message: '* Please fill mandatory fields' };

@Component({
  selector: 'app-signup-agent-loanofficer',
  templateUrl: './signup-agent-loanofficer.component.html',
  styleUrls: ['./signup-agent-loanofficer.component.scss'],
})
export class SignupAgentLoanofficerComponent implements OnInit {
  upgradeSnackbar: MatSnackBarRef<any>;

  valueEmittedFromStripe: boolean;
  addressForm: FormGroup;
  signupForm: FormGroup;
  mlsInfoForm: FormGroup;
  officeForm: FormGroup;
  loanOfficer: FormGroup;
  appraisarForm: FormGroup;
  resetForm: FormGroup;
  stateMlsList = [];
  currentRoute: string = '';
  stateList = constants.STATES;
  onDestroyNotifier$ = new Subject();
  isLoadingStateMLS = false;
  isMobile: boolean = false;
  afterContinueFlag: boolean = false;
  afterContinueloanOfficerFlag: boolean = false;
  isAgentSignUpInProgress: boolean;
  mlsInformation = new MatTableDataSource<any>([]);
  isLoadingAgentMLS: boolean;
  showResetForm: boolean = false;
  isChatRedirect: boolean = false;
  mlsTableColumnList: string[] = ['state', 'mlsBoard', 'memberId', 'status', 'action'];

  alerts: LoginAlerts = errorObj;
  isUserAuthenticationProgress: boolean = false;

  isLoading: boolean = false;
  askUserType: boolean = false;
  userType: string;
  companyLogo = null;
  showCreateAccount: boolean = false;
  showMlsInvalidMessage: boolean = false;
  displayLoanOfficerVerbage: boolean = true;
  isAppraisarSuccess: string;
  hideValuetestLogo: boolean = false;

  initialLoanOfficerValues: {};
  initialappraisarFormValues: {};
  initialMlsInfoFormValues: {};
  initialSignupFormValues: {};
  initialOfficeFormValues: {};
  initialResetFormValues: {};
  reportData: any;
  sellerProperty: any;

  constructor(
    private dialogRef: MatDialogRef<any>,
    private dialog: MatDialog,
    private loginService: LoginService,
    public router: Router,
    private route: ActivatedRoute,
    private formBuilder: FormBuilder,
    private profileService: ProfileService,
    private upperCasePipe: UpperCasePipe,
    private forgotPasswordService: ForgotPasswordService,
    private snackbar: MatSnackBar,
    public appState: AppState,
    private cookieStorageService: CookieStorageService,
    private userState: UserState,
    private reportState: ReportsState,
    private propertyService: PropertyService,
    private cmaState: CmaState,
    public cmaService: CmaService,

    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit(): void {

    if (this.router.url == '/chat') {
      this.isChatRedirect = true;
    }
    if (this.route.snapshot?.url[0]?.path == 'user' || this.router.url == '/chat') {
      this.currentRoute = 'signup';
    } else {
      this.currentRoute = this.route.snapshot.url[0].path;
    }

    this.route.queryParams.subscribe((params) => {
      const utmSource = params['utm_source'];
      if (utmSource) {
        this.cookieStorageService.setCookie('utm_source', utmSource, 7);
        this.displayLoanOfficerVerbage = false;
        this.hideValuetestLogo = true;
      }
    });

    this.appState.companyInfo$.pipe(takeUntil(this.onDestroyNotifier$)).subscribe((res: any) => {
      this.companyLogo = res?.logo?.dark || null;
    });

    this.mlsInfoForm = this.formBuilder.group({
      mlsBoard: [''],
      memberId: [''],
      state: [''],
    });
    this.initialMlsInfoFormValues = this.mlsInfoForm.value;

    this.signupForm = this.formBuilder.group(
      {
        firstName: [
          '',
          Validators.compose([Validators.maxLength(25), Validators.pattern('[a-zA-Z ]*'), Validators.required]),
        ],
        lastName: [
          '',
          Validators.compose([Validators.maxLength(25), Validators.pattern('[a-zA-Z ]*'), Validators.required]),
        ],
        email: ['', [Validators.required, Validators.pattern(constants.regex.validEmail)]],
        phone: [
          '',
          [
            Validators.required,
            Validators.pattern('^(\\+\\d{1,2}\\s?)?1?\\-?\\.?\\s?\\(?\\d{3}\\)?[\\s.-]?\\d{3}[\\s.-]?\\d{4}$'),
          ],
        ],
        password: ['', [Validators.required, Validators.minLength(6)]],
        confirmPassword: ['', [Validators.required, Validators.minLength(6)]],
        // companyName: ['', [Validators.required]],
        streetAddress: [''],
        city: [''],
        state: [''],
        zipCode: [''],
        mlsInfoForm: this.mlsInfoForm,
      },
      { validators: this.passwordMatchValidator('password', 'confirmPassword') }
    );
    this.initialSignupFormValues = this.signupForm.value;

    this.officeForm = this.formBuilder.group({
      email: ['', [Validators.required, Validators.pattern(constants.regex.validEmail)]],
      password: ['', [Validators.required, Validators.minLength(6)]],
    });
    this.initialOfficeFormValues = this.officeForm.value;

    this.resetForm = this.formBuilder.group({
      email: ['', [Validators.required, Validators.pattern(constants.regex.validEmail)]],
    });
    this.initialResetFormValues = this.resetForm.value;

    this.loanOfficer = this.formBuilder.group(
      {
        firstName: [
          '',
          Validators.compose([Validators.maxLength(25), Validators.pattern('[a-zA-Z ]*'), Validators.required]),
        ],
        lastName: [
          '',
          Validators.compose([Validators.maxLength(25), Validators.pattern('[a-zA-Z ]*'), Validators.required]),
        ],
        email: ['', [Validators.required, Validators.pattern(constants.regex.validEmail)]],
        phone: [
          '',
          [
            Validators.required,
            Validators.pattern('^(\\+\\d{1,2}\\s?)?1?\\-?\\.?\\s?\\(?\\d{3}\\)?[\\s.-]?\\d{3}[\\s.-]?\\d{4}$'),
          ],
        ],
        password: ['', [Validators.required, Validators.minLength(6)]],
        confirmPassword: ['', [Validators.required, Validators.minLength(6)]],
        // companyName: ['', [Validators.required]],
        streetAddress: [''],
        city: [''],
        state: [''],
        zipCode: [''],
      },
      { validators: this.passwordMatchValidator('password', 'confirmPassword') }
    );
    this.initialLoanOfficerValues = this.loanOfficer.value;

    this.appraisarForm = this.formBuilder.group({
      firstName: [
        '',
        Validators.compose([Validators.maxLength(25), Validators.pattern('[a-zA-Z ]*'), Validators.required]),
      ],
      lastName: [
        '',
        Validators.compose([Validators.maxLength(25), Validators.pattern('[a-zA-Z ]*'), Validators.required]),
      ],
      email: ['', [Validators.required, Validators.pattern(constants.regex.validEmail)]],
      phone: [
        '',
        [
          Validators.required,
          Validators.pattern('^(\\+\\d{1,2}\\s?)?1?\\-?\\.?\\s?\\(?\\d{3}\\)?[\\s.-]?\\d{3}[\\s.-]?\\d{4}$'),
        ],
      ],
    });
    this.initialappraisarFormValues = this.appraisarForm.value;

    // Detect mobile screen on initialization
    this.isMobile = window.innerWidth < 768;

    // Subscribe to window resize events to update isMobile property
    window.addEventListener('resize', () => {
      this.isMobile = window.innerWidth < 768;
    });

    this.reportState.myReport$.pipe(takeUntil(this.onDestroyNotifier$)).subscribe((data) => {
      this.reportData = data;
    });

    this.cmaState.sellerProperty$.pipe(takeUntil(this.onDestroyNotifier$)).subscribe((data) => {
      this.sellerProperty = data;
    });
  }

  resetAllForms() {
    this.loanOfficer.reset(this.initialLoanOfficerValues);
    this.appraisarForm.reset(this.initialappraisarFormValues);
    this.mlsInfoForm.reset(this.initialMlsInfoFormValues);
    this.signupForm.reset(this.initialSignupFormValues);
    this.officeForm.reset(this.initialOfficeFormValues);
    this.resetForm.reset(this.initialResetFormValues);
    this.isAppraisarSuccess = null;
  }

  /**
   * Closes the dialog from the chat close button.
   *
   * Interceptor flow:
   * - Return an explicit cancellation result.
   *
   * Normal flow:
   * - Preserve the original `close(true)` result used by the chat dialog.
   */
  close(): void {
    if (this.data?.openedFromInterceptor) {
      this.dialogRef.close({
        success: false,
        cancelled: true,
      });
      return;
    }

    this.dialogRef.close(true);
  }

  get signupControls() {
    return this.signupForm.controls;
  }

  get loanOfficerControls() {
    return this.loanOfficer.controls;
  }

  get appraisarControls() {
    return this.appraisarForm.controls;
  }

  get officeFormControls() {
    return this.officeForm.controls;
  }

  get resetFormControls() {
    return this.resetForm.controls;
  }

  okFuncSignup() {
    if (this.mlsInformation.data.filter((e) => e.status === 'invalid').length > 0) {
      this.showMlsInvalidMessage = true;
    } else {
      this.showMlsInvalidMessage = false;
    }
  }

  validateMls() {
    this.okFuncSignup();
    if (this.mlsInformation.data.filter((e) => e.status === 'verified').length > 0) {
      this.showCreateAccount = true;
    } else {
      this.showCreateAccount = false;
    }
  }

  agentSignup() {
    this.isUserAuthenticationProgress = true;

    let reqBody = {
      firstName: this.signupForm.value.firstName,
      lastName: this.signupForm.value.lastName,
      email: this.signupForm.value.email,
      phone: this.signupForm.value.phone,
      sendMail: true,
      mlsList: this.mlsInformation.data,
      password: this.signupForm.value.password,
      address: {
        streetAddress: this.signupForm.value.streetAddress,
        city: this.signupForm.value.city,
        state: this.signupForm.value.state,
        zipCode: this.signupForm.value.zipCode,
      },
    };

    this.profileService
      .signUpForAgentLoanOfficer(reqBody, 'agent')
      .pipe(takeUntil(this.onDestroyNotifier$))
      .subscribe(
        (response: any) => {
          if (
            response &&
            response.status == 'OK' &&
            response.message == 'Success' &&
            response.data &&
            !response.data.status
          ) {
            this.loginService
              .userAuthenticate(this.signupForm.value.email.toLowerCase(), this.signupForm.value.password)
              .pipe(takeUntil(this.onDestroyNotifier$))
              .subscribe(
                (res) => {
                  this.isUserAuthenticationProgress = false;

                  /**
                   * If the interceptor opened this dialog, close with success
                   * and let the interceptor retry the original failed request.
                   */
                  if (this.completeInterceptorAuthentication(res)) {
                    return;
                  }

                  // Preserve the existing normal signup flow.
                  this.redirectAfterSignUp(res);
                  this.signUpSuccessPopup();
                },
                (err) => {
                  this.isUserAuthenticationProgress = false;

                  if (err.message) {
                    this.alerts = { type: 'error', message: err.message };
                  } else {
                    this.alerts = errorObj;
                  }
                  setTimeout(() => {
                    this.alerts = errorObj;
                  }, 3000);
                }
              );
          } else {
            this.isUserAuthenticationProgress = false;
            this.openSnackbar(response.data.status, false);
          }
        },
        (error) => {
          this.isUserAuthenticationProgress = false;
          this.openSnackbar(error.error && error.error.message ? error.error.message : 'Some error occurred !!', false);
        }
      );
  }

  redirectAfterSignUp(res) {

    if (res?.data?.userRoleList?.length > 0) {
      this.userState.getUserRoleValue = res.data.userRoleList[0];

      if (res.data.userRoleList[0] == 'investor' && res.data.leadType == 'buyer' && this.reportData?.cmaReportId) {
        this.router.navigate(['/cma/view'], {
          queryParams: {
            id: this.reportData?.cmaReportId,
            from: 'signup',
          },
        });
      } else if (
        res.data.userRoleList[0] == 'investor' &&
        res.data.leadType == 'seller' &&
        this.reportData?.cmaReportId
      ) {
        let params = {
          pmxPropertyId: this.sellerProperty.pmxPropertyId,
          listingId: this.sellerProperty.listingId,
          userId: res.data.userId,
        };

        let Updateparams = {
          userId: res?.data?.userId,
          cmaReportId: this.reportData?.cmaReportId,
        };
        this.cmaService.addSharedUserId(Updateparams).subscribe({
          next: (response) => {
            if (response.error) {
              console.error('Error adding shared to  userId:', response.error);
            }
          },
          error: (err) => console.error('Unexpected error:', err),
          complete: () => { },
        });

        this.propertyService.addSellerProperty(params).subscribe({
          next: (response) => {
            if (response.error) {
              console.error('Error adding seller property:', response.error);
            } else {
              if (response && response?.homeId) {
                this.router.navigate(['my-property'], {
                  queryParams: {
                    id: response?.homeId,
                  },
                });
              }
            }
          },
          error: (err) => console.error('Unexpected error:', err),
          complete: () => { },
        });
      } else if (this.reportData?.reportId) {
        //res.data.userRoleList[0] == "loanOfficer" &&
        this.router.navigate(['/reports/view'], {
          queryParams: {
            id: this.reportData?.reportId,
            from: 'signup',
          },
        });

      } else if (res.data.userRoleList[0] == 'investor' && this.reportData?.valuetestReportId && this.reportData?.valuetestReportType) {

        this.router.navigate(['/valueReport/shared'], {
          queryParams: {
            id: this.reportData?.valuetestReportId,
            type: this.reportData?.valuetestReportType
          },
        });
      }


      else if (res.data.userRoleList[0] == 'investor' && !this.reportData?.cmaReportId) {
        this.router.navigate(['reports']);
      } else if (this.router.url == '/chat') {
        this.dialogRef.close(true);
        this.router.navigate(['/chat']);
      }
      else {
        this.router.navigate(['dashboard']);
      }
    } else {
      this.router.navigate(['dashboard']);
    }
  }

  /**
   * Logs in an existing agent/loan-officer user.
   *
   * Interceptor flow:
   * - Close with `{ success: true }`.
   * - The interceptor retries the original failed request.
   *
   * Normal flow:
   * - Preserve the existing redirectAfterSignUp navigation behaviour.
   */
  officeFormSubmit(): void {
    if (this.officeForm.invalid || this.isUserAuthenticationProgress) {
      return;
    }

    this.isUserAuthenticationProgress = true;

    const email = this.officeForm.value.email.trim().toLowerCase();
    const password = this.officeForm.value.password;

    this.loginService
      .userAuthenticate(email, password)
      .pipe(takeUntil(this.onDestroyNotifier$))
      .subscribe({
        next: (res: any) => {
          this.isUserAuthenticationProgress = false;

          if (this.completeInterceptorAuthentication(res)) {
            return;
          }

          // Preserve existing navigation for normal login usage.
          this.redirectAfterSignUp(res);
        },

        error: (err: any) => {
          this.isUserAuthenticationProgress = false;

          this.alerts = {
            type: 'error',
            message:
              err?.error?.message ||
              err?.message ||
              'Unable to log in. Please check your credentials.',
          };

          setTimeout(() => {
            this.alerts = errorObj;
          }, 3000);
        },
      });
  }

  /**
   * Closes the dialog with the result expected by HttpInterceptorService.
   *
   * Returns true when interceptor handling was completed so the caller can
   * stop normal redirects and signup-success popups.
   */
  private completeInterceptorAuthentication(response: any): boolean {
    if (!this.data?.openedFromInterceptor) {
      return false;
    }

    this.dialogRef.close({
      success: true,
      response,
    });

    return true;
  }

  /**
   * Closes the dialog from non-chat cancel actions.
   *
   * Normal usage keeps the original empty close result.
   */
  onNoClick(): void {
    if (this.data?.openedFromInterceptor) {
      this.dialogRef.close({
        success: false,
        cancelled: true,
      });
      return;
    }

    this.dialogRef.close();
  }

  resetFormSubmit() {
    this.forgotPasswordService
      .getPasswordResetLink(this.resetForm.value.email)
      .pipe(takeUntil(this.onDestroyNotifier$))
      .subscribe(
        (response: { Message: string }) => {
          if (response && response.Message) {
            this.dialog.open(DialogComponent, {
              width: '355px',
              data: {
                type: 'resetLink',
                message: 'A reset link has been sent to your registered email',
                title: 'Reset Email Sent',
              },
            });
            this.resetForm.reset();
            this.goToLogin();
          }
        },
        (error: { Message: string }) => {
          this.alerts = { type: 'danger', message: error.Message };
          setTimeout(() => {
            this.alerts = errorObj;
          }, 3000);
        }
      );
  }

  isMlsExists() {
    return this.mlsInformation.data.some(
      (val) =>
        val.state == this.mlsInfoForm.value.state &&
        val.mlsBoard == this.mlsInfoForm.value.mlsBoard &&
        val.memberId == this.mlsInfoForm.value.memberId
    );
  }

  addMlsInfo() {
    if (
      !this.mlsInfoForm.value.mlsBoard ||
      this.mlsInfoForm.value.mlsBoard == '' ||
      !this.mlsInfoForm.value.memberId ||
      this.mlsInfoForm.value.memberId == '' ||
      !this.mlsInfoForm.value.state ||
      this.mlsInfoForm.value.state == ''
    ) {
      return false;
    } else if (this.isMlsExists()) {
      this.openSnackbar('This MLS is already Added', false);
      return false;
    } else {
      this.isLoadingAgentMLS = true;
      this.profileService
        .verifyMls(this.mlsInfoForm.value)
        .pipe(takeUntil(this.onDestroyNotifier$))
        .subscribe((res: any) => {
          this.mlsInformation = new MatTableDataSource(this.mlsInformation.data.concat(...res.data));
          this.stateMlsList = [];
          this.mlsInfoForm.reset();
          this.isLoadingAgentMLS = false;
          this.validateMls();
        });
    }
  }

  deleteMLS(mlsId) {
    this.mlsInformation.data.splice(this.mlsInformation.data.indexOf(mlsId), 1);
    this.mlsInformation = new MatTableDataSource(this.mlsInformation.data);
    this.validateMls();
  }

  onUserTyeChange(route) {
    this.resetAllForms();
    this.askUserType = false;
    this.userType = route;
    this.currentRoute = this.userType;
  }

  switchFunc(route) {
    this.resetAllForms();
    this.userType = null;
    this.isAppraisarSuccess = null;
    if (route == 'signup' && !this.askUserType) {
      this.askUserType = true;
    } else {
      this.askUserType = false;
      this.currentRoute = 'signup';
    }
  }

  loanOfficeFormSubmit() {
    this.loanOfficerSignUP();
  }

  appraisarFormSubmit() {
    this.isLoading = true;
    let reqBody = {
      appraiserFirstName: this.appraisarForm.value.firstName,
      appraiserLastName: this.appraisarForm.value.lastName,
      appraiserEmail: this.appraisarForm.value.email,
      appraiserPhone: this.appraisarForm.value.phone,
    };
    this.profileService
      .signUpForAppraisar(reqBody)
      .pipe(takeUntil(this.onDestroyNotifier$))
      .subscribe(
        (response) => {
          if (response && response.status == 'success' && response.message && !response.data) {
            this.isLoading = false;
            this.isAppraisarSuccess = response.message;
          } else {
            this.openSnackbar(response.message, false);
          }
        },
        (error) => {
          this.isLoading = false;
          this.openSnackbar(error.error && error.error.message ? error.error.message : 'Some error occurred !!', false);
        }
      );
  }

  isStateInvalid() {
    const stateControl = this.mlsInfoForm.get('state');
    if (stateControl.errors && stateControl.errors.required) {
      return true;
    } else {
      return stateControl.invalid && (stateControl.dirty || stateControl.touched);
    }
  }

  onStateSelection(event) {
    this.isLoadingStateMLS = true;
    this.profileService
      .getMLSBoards(this.upperCasePipe.transform(event.value), true)
      .pipe(takeUntil(this.onDestroyNotifier$))
      .subscribe(({ isLoading, mlsBoard }: any) => {
        this.stateMlsList = [];
        this.isLoadingStateMLS = isLoading;
        if (mlsBoard && mlsBoard.length) {
          this.stateMlsList = mlsBoard;
        }
      });
  }

  backFunc() {
    this.afterContinueFlag = false;
  }

  onConfirmPasswordInput() {
    this.signupForm.get('confirmPassword').markAsDirty();
    this.signupForm.updateValueAndValidity();
  }

  passwordMatchValidator(controlName: string, matchingControlName: string): ValidatorFn {
    return (formGroup: AbstractControl): ValidationErrors | null => {
      const passwordControl = formGroup.get(controlName);
      const confirmPasswordControl = formGroup.get(matchingControlName);

      if (!passwordControl || !confirmPasswordControl) {
        return null;
      }

      if (passwordControl.value !== confirmPasswordControl.value) {
        confirmPasswordControl.setErrors({ passwordMismatch: true });
      } else {
        confirmPasswordControl.setErrors(null);
      }
      return null;
    };
  }

  goToLogin() {
    this.showResetForm = false;
  }

  goToReset() {
    this.showResetForm = true;
  }

  loanOfficerSignUP() {
    this.isLoading = true;
    const utmSource = this.cookieStorageService.getCookieValue('utm_source');

    let reqBody = {
      firstName: this.loanOfficer.value.firstName,
      lastName: this.loanOfficer.value.lastName,
      email: this.loanOfficer.value.email,
      phone: this.loanOfficer.value.phone,
      sendMail: true,
      utmSource: utmSource,
      // companyName: this.loanOfficer.value.companyName,
      loanApplicationUrl: 'http://lenderdemo.propmix.io/',
      password: this.loanOfficer.value.password,
      address: {
        streetAddress: this.loanOfficer.value.streetAddress,
        city: this.loanOfficer.value.city,
        state: this.loanOfficer.value.state,
        zipCode: this.loanOfficer.value.zipCode,
      },
    };
    this.profileService
      .signUpForAgentLoanOfficer(reqBody, 'loanOfficer')
      .pipe(takeUntil(this.onDestroyNotifier$))
      .subscribe(
        (response) => {
          if (
            response &&
            response.status == 'OK' &&
            response.message == 'Success' &&
            response.data &&
            !response.data.status
          ) {
            this.loginService
              .userAuthenticate(this.loanOfficer.value.email.toLowerCase(), this.loanOfficer.value.password)
              .pipe(takeUntil(this.onDestroyNotifier$))
              .subscribe(
                (res) => {
                  this.isLoading = false;

                  /**
                   * Support account creation from an interceptor-opened dialog.
                   * Once authentication succeeds, retry the original request.
                   */
                  if (this.completeInterceptorAuthentication(res)) {
                    return;
                  }

                  // Preserve the existing normal signup flow.
                  this.redirectAfterSignUp(res);
                  this.signUpSuccessPopup();
                },
                (err) => {
                  this.openSnackbar(err.message, false);
                }
              );
          } else {
            this.isLoading = false;
            this.openSnackbar(response.data.status, false);
          }
        },
        (error) => {
          this.isLoading = false;
          this.openSnackbar(error.error && error.error.message ? error.error.message : 'Some error occurred !!', false);
        }
      );
  }

  stripeSubmitFun(valueEmitted) {
    this.valueEmittedFromStripe = valueEmitted;
    if (this.valueEmittedFromStripe) {
      this.signUpSuccessPopup();
      this.router.navigate(['dashboard']);
    }
  }

  signUpSuccessPopup() {
    this.dialog.open(DialogComponent, {
      width: '355px',
      data: {
        type: 'signUpSuccess',
        message:
          '<b class="p-1">Just One More Step</b>' +
          '<div class="p-1">We have sent you an activation email.</div>' +
          '<div class="p-1">Please click on the link in the email to verify your account to access all the features.</div>' +
          '<div class="p-1">Please check your spam just in case.</div>',
        title: 'Signup Completed',
      },
    });
  }

  openSnackbar(upgradeMsg, success = false) {
    this.upgradeSnackbar = this.snackbar.open(upgradeMsg, 'Dismiss', {
      duration: 5000,
      panelClass: [success ? 'snackbar-success' : 'snackbar-error'],
      verticalPosition: 'top',
    });
  }
}